import React, { useState } from 'react';
import { BsFileText } from 'react-icons/bs'; // Changed to use BsFileText from react-icons/bs
import TableComponent from './../../components/widgets/table/index';

function Commissions() {
  const allCommissionData = [
    { id: 1, agent: 'John Doe', amount: 250.00, source: 'Sale INV001', status: 'Paid', date: '2025-01-25' },
    { id: 2, agent: 'Jane Smith', amount: 150.75, source: 'Renewal RNW001', status: 'Pending', date: '2025-01-28' },
    { id: 3, agent: 'John Doe', amount: 50.00, source: 'Sale INV003', status: 'Paid', date: '2025-02-10' },
    { id: 4, agent: 'Peter Jones', amount: 300.00, source: 'Sale INV004', status: 'Paid', date: '2025-02-15' },
    { id: 5, agent: 'Jane Smith', amount: 80.00, source: 'Sale INV005', status: 'Pending', date: '2025-03-10' },
    { id: 6, agent: 'John Doe', amount: 100.50, source: 'Renewal RNW002', status: 'Paid', date: '2025-03-20' },
    { id: 7, agent: 'Peter Jones', amount: 75.00, source: 'Sale INV007', status: 'Paid', date: '2025-04-10' },
    { id: 8, agent: 'Jane Smith', amount: 200.00, source: 'Sale INV008', status: 'Pending', date: '2025-04-30' },
    { id: 9, agent: 'John Doe', amount: 120.00, source: 'Renewal RNW003', status: 'Paid', date: '2025-05-10' },
    { id: 10, agent: 'Peter Jones', amount: 90.00, source: 'Sale INV010', status: 'Paid', date: '2025-05-20' },
    { id: 11, agent: 'Jane Smith', amount: 350.00, source: 'Sale INV011', status: 'Pending', date: '2025-06-10' },
    { id: 12, agent: 'John Doe', amount: 60.00, source: 'Renewal RNW004', status: 'Paid', date: '2025-06-30' },
    { id: 13, agent: 'Peter Jones', amount: 180.00, source: 'Sale INV013', status: 'Paid', date: '2025-07-15' },
    { id: 14, agent: 'Jane Smith', amount: 40.00, source: 'Renewal RNW005', status: 'Pending', date: '2025-07-20' },
    { id: 15, agent: 'John Doe', amount: 280.00, source: 'Sale INV015', status: 'Paid', date: '2025-08-10' },
    { id: 16, agent: 'Peter Jones', amount: 100.00, source: 'Sale INV016', status: 'Paid', date: '2025-08-14' },
    { id: 17, agent: 'Jane Smith', amount: 220.00, source: 'Sale INV017', status: 'Pending', date: '2025-09-05' },
    { id: 18, agent: 'John Doe', amount: 80.00, source: 'Renewal RNW006', status: 'Paid', date: '2025-09-10' },
  ];

  const months = [
    { name: 'January', value: 0 }, { name: 'February', value: 1 }, { name: 'March', value: 2 },
    { name: 'April', value: 3 }, { name: 'May', value: 4 }, { name: 'June', value: 5 },
    { name: 'July', value: 6 }, { name: 'August', value: 7 }, { name: 'September', value: 8 },
    { name: 'October', value: 9 }, { name: 'November', value: 10 }, { name: 'December', value: 11 }
  ];

  const currentMonth = new Date().getMonth();
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [showCards, setShowCards] = useState(true);

  const filteredCommissionData = allCommissionData.filter(item => {
    const itemMonth = new Date(item.date).getMonth();
    return itemMonth === selectedMonth;
  });

  const getCountForMonth = (monthValue) => {
    return allCommissionData.filter(item => new Date(item.date).getMonth() === monthValue).length;
  };

  const commissionTableFields = [
    { name: 'Agent' },
    { name: 'Amount' },
    { name: 'Source' },
    { name: 'Status' },
    { name: 'Date' },
  ];

  const commissionRowData = [
    { type: 'text', field: 'agent' },
    { type: 'currency', field: 'amount' },
    { type: 'text', field: 'source' },
    { type: 'status', field: 'status' },
    { type: 'date', field: 'date' },
  ];

  const handleMonthClick = (monthValue) => {
    setSelectedMonth(monthValue);
    setShowCards(false);
  };

  return (
    <div className="min-vh-100 bg-light pb-5">
      <div className="bg-white shadow-sm border-bottom">
        <div className="container py-4">
          <h1 className="h3 font-weight-bold text-dark">Commissions</h1>
          <p className="text-muted mb-0">Overview of all commissions by month.</p>
        </div>
      </div>

      <div className="container py-5">
        {showCards ? (
          <div className="d-flex flex-wrap justify-content-start align-items-stretch" style={{ gap: '2rem' }}>
            {months.map((month, index) => (
              <div key={index} style={{ flex: '0 0 calc(25% - 1.5rem)', maxWidth: 'calc(25% - 1.5rem)', marginTop: '2rem' }}>
                <div
                  className="card h-100 border-0 shadow-sm text-center py-4 cursor-pointer rounded"
                  onClick={() => handleMonthClick(month.value)}
                >
                  <div className="card-body d-flex flex-column align-items-center justify-content-center">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center mb-2"
                      style={{ backgroundColor: '#10b981', width: '64px', height: '64px' }} // Commissions color from Reports page
                    >
                      <BsFileText className="text-white" size={32} />
                    </div>
                    <h2 className="font-weight-bold mb-0 text-dark">{getCountForMonth(month.value)}</h2>
                    <p className="card-text mt-2 mb-0 text-dark">{month.name}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <TableComponent
            title={`Commissions for ${months[selectedMonth].name}`}
            table_fields={commissionTableFields}
            row_data={commissionRowData}
            table_data={filteredCommissionData}
          />
        )}
      </div>
    </div>
  );
}

export default Commissions;
